import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArVrFormComponent } from './ar-vr-form/ar-vr-form.component';

const routes: Routes = [{ path: '', component: ArVrFormComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
